// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__DcANB","noInteraction":"EventWrapper_noInteraction__1CkL5"};